exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-active-ring-chart{position:relative}.dv-active-ring-chart .active-ring-chart-container{width:100%;height:100%}.dv-active-ring-chart .active-ring-info{position:absolute;width:100%;height:100%;left:0;top:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.dv-active-ring-chart .active-ring-info .dv-digital-flop{width:100px;height:30px}.dv-active-ring-chart .active-ring-info .active-ring-name{width:100px;height:30px;color:#fff;text-align:center;vertical-align:middle;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/activeRingChart/src/main.css
// module id = 1067
// module chunks = 45